import { Component, ElementRef, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { NewsNotifications } from '../core/objects/news-notifications';
import { NavigationService } from '../core/services/navigation.service';
import { NewsNotificationsService } from '../core/services/news-notifications.service';
import { UserApiService } from '../core/services/user-api.service';
import { HEIGHT_ANIMATION } from '../shared/animations/animations';
import { ClickedOutsideDirective } from '../shared/directives/clicked-outside.directive';

@Component({
    selector: 'gl-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    animations: [HEIGHT_ANIMATION],
    standalone: false
})
export class NewsComponent extends ClickedOutsideDirective implements OnDestroy {
  public newsNotifications: NewsNotifications;
  public subscriptions: Subscription[] = [];

  constructor(
    elRef: ElementRef,
    private navigationService: NavigationService,
    private newsNotificationsService: NewsNotificationsService,
    private userApiService: UserApiService,
    private translate: TranslateService,
  ) {
    super(elRef);
    this.subscriptions.push(
      this.glClickedOutside.subscribe(() => this.navigationService.navigateToHomepage()),
    );
    this.userApiService.getNewsNotifications(this.translate.currentLang).subscribe(() => {
      this.getNotifications();
      this.markSeen();
    });
  }

  public getNotifications() {
    this.newsNotifications = this.newsNotificationsService.getState();
  }

  public markSeen() {
    const seenNotificationsIds = [];
    this.newsNotifications.newsNotifications.forEach((newsNotification) => {
      if (newsNotification.state === 'new') {
        seenNotificationsIds.push(newsNotification.id);
      }
    });
    if (seenNotificationsIds.length > 0) {
      this.userApiService
        .markSeenNewsNotifications(this.translate.currentLang, seenNotificationsIds)
        .subscribe();
    }
  }

  public ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
